'use strict'

import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import SelectManager from 'assets/core/js/module/selectManager'
import HelpTooltipManager from 'assets/core/js/module/helpTooltipManager'
import { Facets } from 'assets/themes/campings/js/page/product/facets'
import { AccommodationsData, AccommodationsOrder } from 'assets/core/js/types/globals'
import elementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export default function (facets: Facets): void {
  const resultsEl = document.querySelector('[data-partial-id="results"]')

  if (resultsEl) {
    resultsEl.addEventListener(PartialsEvents.POST_UPDATE, (e: Event) => {
      const detail = (e as CustomEvent).detail as {
        data: {
          accommodationsData: AccommodationsData
          accommodationsOrder: AccommodationsOrder
        }
      }

      if (detail && detail.data) {
        window.accommodationsData = detail.data.accommodationsData
        window.accommodationsOrder = detail.data.accommodationsOrder
      }
      facets.sortAccommodations()
    })
  }

  const searchFormEl = document.querySelector('[data-partial-id="searchForm"]')
  const helpTooltip = HelpTooltipManager.getHelpTooltip('product-checkInDate')

  if (searchFormEl) {
    searchFormEl.addEventListener(PartialsEvents.POST_UPDATE, (e) => {
      const detail = (e as CustomEvent).detail as {
        data: { [key: string]: { choices: Record<string, string>; value: string } }
      }

      if (detail && detail.data) {
        for (const key in detail.data) {
          const data = detail.data[key]

          if (!data) {
            return
          }

          SelectManager.clear(key)
          SelectManager.setValues(key, data)
            .then(() => true)
            .catch(() => true)
        }
      }

      const calendar = elementPropertiesManager.getProperty<SearchCalendarType>(
        document.getElementById('checkInDate') as HTMLInputElement,
        'calendar'
      )

      if (helpTooltip && calendar?.input.value !== '') {
        helpTooltip.close()
      }
    })
  }
}
